import { IDynamicActionsBrickAction } from 'src/app/components/bricks/dynamic-actions-brick/dynamic-actions-brick-configuration/dynamic-actions-brick-configuration';

export class UpdateDynamicActionsBrickConfiguration {
   public static readonly type = '[Dynamic Actions Behavior] Update JSON Configuration';

   constructor(public brickInstanceId: string, public jsonConfiguration: string) {}
}

export class ExecuteDynamicActionsBrickUserActions {
   public static readonly type = '[Dynamic Actions Behavior] Execute User Actions';

   constructor(public actions: IDynamicActionsBrickAction[]) {}
}

export class ExecuteDynamicActionsBrickUserAction {
   public static readonly type = '[Dynamic Actions Behavior] Execute User Action';

   constructor(public action: IDynamicActionsBrickAction) {}
}
